"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Field = _interopRequireDefault(require("../field/Field"));

var _Select = _interopRequireDefault(require("../select/Select"));

var _generateUniqueId = require("../../utils/generateUniqueId");

require("./SelectField.css");

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SelectField = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SelectField, _Component);

  var _super = _createSuper(SelectField);

  function SelectField(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, SelectField);
    _this = _super.call(this, props);
    _this.forId = "stxField".concat((0, _generateUniqueId.generateUniqueId)());
    _this.messageId = "stxFieldMessage".concat((0, _generateUniqueId.generateUniqueId)());
    return _this;
  }

  (0, _createClass2["default"])(SelectField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          label = _this$props.label,
          className = _this$props.className,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          messageType = _this$props.messageType,
          messageText = _this$props.messageText,
          messageId = _this$props.messageId,
          helpText = _this$props.helpText,
          ariaLive = _this$props.ariaLive,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["id", "label", "className", "disabled", "readOnly", "messageType", "messageText", "messageId", "helpText", "ariaLive"]);
      var classNames = (0, _classnames["default"])(['stx-field--with-select', className]);
      var hasValidationError = messageType === 'alert' || messageType === 'error';
      return /*#__PURE__*/_react["default"].createElement(_Field["default"], {
        label: label,
        htmlFor: id || this.forId,
        helpText: helpText,
        className: classNames,
        messageType: messageType,
        messageText: messageText,
        messageId: messageId || this.messageId,
        disabled: disabled,
        readOnly: readOnly,
        ariaLive: ariaLive
      }, /*#__PURE__*/_react["default"].createElement(_Select["default"], (0, _extends2["default"])({}, otherProps, {
        id: id || this.forId,
        messageType: messageType,
        disabled: disabled,
        readOnly: readOnly,
        "aria-invalid": hasValidationError ? 'true' : undefined,
        "aria-describedby": messageId || this.messageId
      })));
    }
  }]);
  return SelectField;
}(_react.Component);

SelectField.defaultProps = {};
SelectField.propTypes = {
  /** The name or the title of the field */
  label: _propTypes["default"].node,

  /** Helpful text that describes how to use the field */
  helpText: _propTypes["default"].node,

  /** HTML ID attribute for the select element */
  id: _propTypes["default"].string,

  /** Name for the select component */
  name: _propTypes["default"].string,

  /** The value for the select component */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Optional className for the select component */
  className: _propTypes["default"].string,

  /** Placeholder for the select component */
  placeholder: _propTypes["default"].string,

  /** The text for the message */
  messageText: _propTypes["default"].string,

  /** The type of message to display */
  messageType: _propTypes["default"].oneOf(['alert', 'warning', 'success', '']),

  /** The ID of the associated message element (automatically generated if not provided) */
  messageId: _propTypes["default"].oneOf([_propTypes["default"].string, _propTypes["default"].undefined]),

  /** The aria-live attribute value that will be set on the message if one is given */
  ariaLive: _propTypes["default"].oneOf(['assertive', 'polite']),

  /** The order in which fields should gain focus when pressing Tab */
  tabIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),

  /** Whether or not the field is disabled */
  disabled: _propTypes["default"].bool,

  /** Whether or not the field is loading */
  loading: _propTypes["default"].bool,

  /** Whether or not the field is read only */
  readOnly: _propTypes["default"].bool,

  /** An array of objects that can be used to build the option set */
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })),

  /** Event fires when the field gains focus */
  onFocus: _propTypes["default"].func,

  /** Event fires when the field loses focus */
  onBlur: _propTypes["default"].func,

  /** Event fires when the field's value changes */
  onChange: _propTypes["default"].func,

  /** Child elements */
  children: _propTypes["default"].node
};
var _default = SelectField;
exports["default"] = _default;